module.exports = __webpack_public_path__ + "img/F_image14.b119c268.jpg";